import { Divider, IconButton, Typography } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { DrawerWrapper, TitleWrapper } from "../style";
import useLanguage from "../../../hooks/useLanguage";
import MarkdownEditor from "../../../components/MarkdownEditor";
import SimpleTextEditor from "../../../components/simpleTextEditor";

const documentTypeXname = {
  robotstxt: "yaml",
  adstxt: "text",
  sitemap: "xml",
  about: "markdown",
  privacy: "markdown",
  terms: "markdown",
  contact: "markdown",
};

export default function FileEditDrawer({ name, onChange, value, onClose }) {
  const [
    {
      pages: {
        configurations: { fileDrawer: text },
      },
    },
  ] = useLanguage();

  const handleChange = (content) =>
    onChange({ target: { name: name, value: content } });

  return (
    <DrawerWrapper>
      <TitleWrapper>
        <Typography variant="h5">
          {text.title} {name}
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseRoundedIcon fontSize="small" />
        </IconButton>
      </TitleWrapper>
      <Typography variant="body2">{text.description}</Typography>
      <Divider />
      {documentTypeXname[name] === "markdown" ? (
        <MarkdownEditor value={value} onChange={handleChange} />
      ) : (
        <SimpleTextEditor
          height="100%"
          language={documentTypeXname[name]}
          value={value}
          onChange={handleChange}
        />
      )}
    </DrawerWrapper>
  );
}
